<template>
  <div id="content-wrap" class="content-wrapper">
    <section class="content">
      <div class="col-md-12 col-sm-12 col-xs-12">
        <va-box theme="box-primary" title="Danh sách Ext">
          <div slot="content">
            <b-table    bordered outlined hover responsive :busy="loading" :fields="fields" :items="items" show-empty>
              <template #table-busy>
                <div class="text-center my-2 mt-5 mb-5">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Đang tải...</strong>
                </div>
              </template>

              <template #empty="scope">
                <h4 class="text-center text-bold mt-5 mb-5">Không có dữ liệu</h4>
              </template>

              <template v-slot:cell(user)="data">
                <multiselect v-model="data.item.user" id="ajax" label="name" track-by="code"
                             placeholder="Nhập để tìm kiếm người dùng"
                             open-direction="bottom" :options="users" :multiple="false" :searchable="true"
                             :loading="loadingUser" :internal-search="true" :clear-on-select="true"
                             :close-on-select="true" :options-limit="300" :limit="2" :max-height="600"
                             @select="onSelectUser($event, data.item)" @remove="onRemoveUser($event, data.item)"
                             :allow-empty="true"
                             :show-no-results="false" :hide-selected="false" @search-change="debounceUser">
                  <span slot="noResult">Không tìm thấy kết quả nào.</span>
                </multiselect>
              </template>

              <template v-slot:cell(actions)="dataId">
                <b-button variant="warning" v-b-tooltip.hover title="Cập nhật" @click="save(dataId.item)"><i
                  class="fa fa-floppy-o"/></b-button>
              </template>

            </b-table>
          </div>
          <div slot="footer" class="d-flex align-items-center justify-content-between">
            <div class="page-size-container">
              <span>Hiển thị</span>
              <b-form-select
                id="pageSize"
                v-model="pageSize"
                :options="pageSizes"
                required
              ></b-form-select>
              <span>  dòng</span>
            </div>
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRow"
              :per-page="pageSize"
              aria-controls="my-table"
            ></b-pagination>
          </div>
        </va-box>
      </div>
    </section>
  </div>
</template>

<script>
import VABox from 'va/widgets/VABox.vue'
import {debounce} from 'lodash'
import UserApi from '../../api/user'
import Utils from '../../common/utils'
import Multiselect from '../../lib/vue-multiple-select/Multiselect'
import callCenterAPI from '../../api/callCenter'
import {mapGetters} from 'vuex'
import {MAX_SALE_USER_NUMBER} from '../../common/constant'

export default {
  name: 'ExtUserManagement',
  components: {
    'va-box': VABox,
    Multiselect
  },
  computed: {
    ...mapGetters([
      'userInfo'
    ])
  },
  data () {
    return {
      company: null,
      items: [],
      fields: [
        {
          key: 'id',
          label: 'ID',
          thStyle: 'width: 10%',
        },
        {
          key: 'name',
          label: 'EXT',
          thStyle: 'width: 40%',
        },
        {
          key: 'user',
          label: 'Người dùng',
          thStyle: 'width: 50%',
        }
      ],
      loading: false,
      pageSize: 10,
      currentPage: 1,
      totalRow: 0,
      pageSizes: [
        {text: 100, value: 100},
        {text: 50, value: 50},
        {text: 20, value: 20},
        {text: 10, value: 10}
      ],
      users: [],
      loadingUser: false,
      debounceUser: null,
    }
  },
  mounted () {
    this.company = Utils.getCompanyByUserInfo(this.userInfo)
    this.filterUser()
    this.getAgents()
  },
  created () {
    this.debounceUser = debounce(this.filterUser.bind(this), 500)
  },
  methods: {
    getAgents () {
      callCenterAPI.get_agents({}).then(res => {
        this.loading = false
        this.items = res.data.data.map(agent => {
          return {
            id: agent.id,
            name: agent.name,
            user: {
              name: agent.user_name,
              code: agent.user_id
            }
          }
        })
        this.totalRow = res.data.data.total
      }).catch(err => {
        this.loading = false
        Utils.handleError(this.$bvToast, err)
      })
    },
    onSelectUser (event, ext) {
      callCenterAPI.update_agents({
        id: ext.id,
        user_id: event.code
      }).then(res => {
        Utils.successToast(this.$bvToast)
        this.filter()
      }).catch(err => {
        Utils.handleError(this.$bvToast, err)
      })
    },
    onRemoveUser (event, ext) {
      callCenterAPI.update_agents({
        id: ext.id,
        user_id: null
      }).then(res => {
        Utils.successToast(this.$bvToast)
        this.filter()
      }).catch(err => {
        Utils.handleError(this.$bvToast, err)
      })
    },
    filterUser (query) {
      this.loadingUser = true
      UserApi.findByName(query, this.company.id, 0, MAX_SALE_USER_NUMBER).then(res => {
        this.users = res.data.data.records.map(item => {
          return {'name': item.username, 'code': item.id}
        })
        this.loadingUser = false
      }).catch(err => {
        Utils.handleError(this.$bvToast, err)
        this.loadingUser = false
      })
    },
  },
  watch: {
    currentPage: {
      handler: function () {
        this.filter()
      }
    },
    pageSize: {
      handler: function () {
        this.filter()
      }
    }
  }
}
</script>

<style scoped>
  .multiselect-v2 {
    position: initial!important;
  }
</style>



// WEBPACK FOOTER //
// src/views/call_center/ExtUserManagement.vue